import React from "react";
import "./We_Shape.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const We_Shape = () => {
  return (
    <section className="We_Shape">
      <div className="container">
        <div className="content_div">
          <div className="info_div">
            <Common_Title
              pageTitle="SINCE 2015"
              boxText={"We Shape "}
              subText={"Timeless & Inspiring Spaces"}
            />

            <p className="yr_text">20</p>
            <p className="exp_text">Years of </p>
            <p className="exp_text">Experience </p>

            <div className="bottom_div">
              <p className="simple_text">
                Tech Interiors and Designers has become a trusted name in Pune
                and across Maharashtra.
              </p>

              <p className="simple_text">
                Founded with the vision of delivering quality, creativity, and
                functionality, we specialize in both residential and commercial
                interiors.
              </p>

               <p className="simple_text">
               Our philosophy is simple <b>“Designs that reflect you.”</b>
              </p>

               <p className="simple_text">
              We work closely with clients, understand their lifestyle, needs, and budget, and then craft
customized solutions that balance <b>aesthetics with practicality</b>.
              </p>
            </div>
          </div>

          <div className="right_abs_div">
            <img
              src="/assets/images/about_us/we_shape/img.png"
              className="abs_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default We_Shape;
